import { pageCache } from './pageCache'

/**
 * "리스트를 새로 만들고 원래 자리로 돌아오기" 를 이어 주는 쪽지.
 *
 * 만들기는 바텀시트가 아니라 전체 페이지(/platelist/new)다. 거기로 가면
 * 원래 화면이 통째로 내려갔다가 돌아올 때 새로 만들어진다 — 열려 있던 시트도,
 * 체크해 둔 것도 사라진다. 그래서 떠나기 전에 여기 적어두고 돌아와서 읽는다.
 *
 * 왜 주소(state)가 아니라 따로 두나
 * --------------------------------
 * 만들기 화면은 끝나면 navigate(-1) 로 돌아간다. 뒤로가기에는 값을 실어 보낼
 * 수 없다. 억지로 실으려면 만들기 화면이 "누가 불렀는지" 를 알아야 하는데,
 * 그러면 부르는 쪽이 늘 때마다 만들기 화면을 고치게 된다.
 *
 * 페이지 이동은 앱 안에서만 일어나므로(새로고침이 아니다) 이 쪽지는 그대로
 * 남아 있다. 한 번 읽으면 지운다 — 다음에 그냥 들어왔을 때 시트가 저절로
 * 열리면 안 된다.
 */
export interface PlatelistCreateReturn {
  /** 돌아갈 자리를 가리는 이름. 화면마다 다르게 준다 */
  key: string
  /** 떠나기 전 체크돼 있던 리스트 */
  checked: string[]
  /** 화면이 알아서 쓰는 값 (인스타 해석 결과 등) */
  payload?: unknown
}

const SLOT = 'platelist-create-return'
const MADE = 'platelist-create-made'

/** 떠나기 전에 적어둔다 */
export const rememberBeforeCreate = (note: PlatelistCreateReturn): void => {
  pageCache.set(SLOT, note)
}

/** 만들기가 끝났을 때 새 리스트 id 를 적는다 (만들기 화면이 부른다) */
export const rememberCreated = (categoryId: string): void => {
  pageCache.set(MADE, categoryId)
}

/**
 * 돌아왔을 때 한 번만 읽는다. 내 쪽지가 아니면 건드리지 않는다.
 *
 * @returns 쪽지 + 방금 만든 리스트 id (취소하고 돌아왔으면 id 는 null)
 */
export const takeAfterCreate = (
  key: string
): { checked: string[]; payload?: unknown; createdId: string | null } | null => {
  const note = pageCache.get(SLOT) as PlatelistCreateReturn | undefined
  if (!note || note.key !== key) return null

  const createdId = (pageCache.get(MADE) as string | undefined) ?? null
  pageCache.remove(SLOT)
  pageCache.remove(MADE)

  return { checked: note.checked, payload: note.payload, createdId }
}
